
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as lpPeULCK6pVF42z_K_9faFgxzJnN89AqHu63FWtW_45AkhsMeta } from "/app/pages/lp.vue?macro=true";
import { default as txsIe5yRWndhQtEJEURUmRYJeNJ6j3130CIy9Q9aBsJsK0Meta } from "/app/pages/txs.vue?macro=true";
import { default as cardsqx1jMch_45ABk8CQEBHkeTls2ZbGBKMsDjo_XTYXnpx88Meta } from "/app/pages/cards.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as usersfwkWStBj7bsR6vrbpmu_yeS56djFcxtb3JU1R98uVV4Meta } from "/app/pages/users.vue?macro=true";
import { default as profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta } from "/app/pages/profile.vue?macro=true";
import { default as indexVbTqsRZ8ivU0twVLNNQVr2sJSPa1OLi2oeqFWQlQ3hQMeta } from "/app/pages/cc/index.vue?macro=true";
import { default as indexbYcmpcN6Oq9NnPreaGEKfehHVEs7Ul_45apxhxzlefbwIMeta } from "/app/pages/fg/index.vue?macro=true";
import { default as paymentMxWenglIQR4M2K6A_45ehP_4588Z3m_9cSooqfuMEOfd8OEMeta } from "/app/pages/fg/payment.vue?macro=true";
import { default as main_reportM8mT9a5MKVqxelZjVYRuIGQjH7JO9M5P7HMX_453mJmrwMeta } from "/app/pages/main_report.vue?macro=true";
import { default as expenses43P0H4E5MwvaNPbOvYfSIUOj_DqS1tiPzZsu8nS9gd0Meta } from "/app/pages/fin/expenses.vue?macro=true";
import { default as access_45deniedyHIOCACFsmpwjlfzNSutDWeVNnmI4q3U6OE5LDoq354Meta } from "/app/pages/access-denied.vue?macro=true";
import { default as master_45accountYJnwQOhC8TDEdB313gTEPg6OmAiytrhssYp9y0sDIUwMeta } from "/app/pages/master-account.vue?macro=true";
import { default as main_report_new8bgCwrCGgI8Q_UNXl17vx2HxAJyx32zRkcoffPA7iwUMeta } from "/app/pages/main_report_new.vue?macro=true";
import { default as main_report_old5G8O_aQqdqpFGd6VbMWnK1QhDegxD2PoMfkUxBv32tAMeta } from "/app/pages/main_report_old.vue?macro=true";
import { default as test_main_reportgI6KM0auVj2vwOm4oXRuM0U6mwfN4CLUzApXq_45e0vCsMeta } from "/app/pages/test_main_report.vue?macro=true";
import { default as index5pLzhte9TQJTRsGOs2AddcvDJPJut_pUUCJmurfv3M0Meta } from "/app/pages/admin/roles/index.vue?macro=true";
import { default as indexgvs7WdV1NLBsiIM1p5V4txUPTMYikQ1vfsYYESmgxtgMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as pgyHCSW7We_pKXPQyeHZOXwECm6fdXBMB4xQkN_451V4UqEMeta } from "/app/pages/cc/datasources/pg.vue?macro=true";
import { default as cards_issue_ordersZYFh5Zeh9bB2pT8w0l3E_todAVsTlfwrK_czSwwcbXsMeta } from "/app/pages/cards_issue_orders.vue?macro=true";
import { default as cards_topup_orders9QdadP3U7cAWUOz8EVcZu5Oa1F70c7BT66KyZukKnocMeta } from "/app/pages/cards_topup_orders.vue?macro=true";
import { default as indexFPuOMcyN5u9oBVIt2dUJ0FqFp5xmUq5crf6Zbhm4qc0Meta } from "/app/pages/trader_deposit_rub/index.vue?macro=true";
export default [
  {
    name: "lp",
    path: "/lp",
    component: () => import("/app/pages/lp.vue")
  },
  {
    name: "txs",
    path: "/txs",
    component: () => import("/app/pages/txs.vue")
  },
  {
    name: "cards",
    path: "/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/app/pages/users.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "cc",
    path: "/cc",
    component: () => import("/app/pages/cc/index.vue")
  },
  {
    name: "fg",
    path: "/fg",
    component: () => import("/app/pages/fg/index.vue")
  },
  {
    name: "fg-payment",
    path: "/fg/payment",
    meta: paymentMxWenglIQR4M2K6A_45ehP_4588Z3m_9cSooqfuMEOfd8OEMeta || {},
    component: () => import("/app/pages/fg/payment.vue")
  },
  {
    name: "main_report",
    path: "/main_report",
    component: () => import("/app/pages/main_report.vue")
  },
  {
    name: "fin-expenses",
    path: "/fin/expenses",
    component: () => import("/app/pages/fin/expenses.vue")
  },
  {
    name: "access-denied",
    path: "/access-denied",
    meta: access_45deniedyHIOCACFsmpwjlfzNSutDWeVNnmI4q3U6OE5LDoq354Meta || {},
    component: () => import("/app/pages/access-denied.vue")
  },
  {
    name: "master-account",
    path: "/master-account",
    component: () => import("/app/pages/master-account.vue")
  },
  {
    name: "main_report_new",
    path: "/main_report_new",
    component: () => import("/app/pages/main_report_new.vue")
  },
  {
    name: "main_report_old",
    path: "/main_report_old",
    component: () => import("/app/pages/main_report_old.vue")
  },
  {
    name: "test_main_report",
    path: "/test_main_report",
    component: () => import("/app/pages/test_main_report.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    component: () => import("/app/pages/admin/roles/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/app/pages/admin/users/index.vue")
  },
  {
    name: "cc-datasources-pg",
    path: "/cc/datasources/pg",
    component: () => import("/app/pages/cc/datasources/pg.vue")
  },
  {
    name: "cards_issue_orders",
    path: "/cards_issue_orders",
    component: () => import("/app/pages/cards_issue_orders.vue")
  },
  {
    name: "cards_topup_orders",
    path: "/cards_topup_orders",
    component: () => import("/app/pages/cards_topup_orders.vue")
  },
  {
    name: "trader_deposit_rub",
    path: "/trader_deposit_rub",
    component: () => import("/app/pages/trader_deposit_rub/index.vue")
  }
]